module.exports = __webpack_public_path__ + "img/photo_2021-05-20_17-04-52.ab8cc69c.png";